enum TotalEnum {
  COST = 'cost',
  MPERCENT = 'mpercent',
  MVALUE = 'mvalue',
  FEE = 'fee',
}

export default TotalEnum
